import { render, staticRenderFns } from "./dropdown-source.vue?vue&type=template&id=71966ed4&"
import script from "./dropdown-source.vue?vue&type=script&lang=js&"
export * from "./dropdown-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports